import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import MenuShell from '../components/MenuShell';
import { useAuth } from '../features/auth/AuthContext';
import './HomePage.css';

const DEMO_COURSE_ID = 'first';

interface HomeCard {
  key: string;
  to: string;
  titleKey: string;
  descriptionKey: string;
}

function buildCards(isAuthenticated: boolean, role: string | null): HomeCard[] {
  const cards: HomeCard[] = [
    { key: 'challenge', to: '/exercise/first', titleKey: 'challenge', descriptionKey: 'challenge' },
    {
      key: 'joinClass',
      to: `/courses/${DEMO_COURSE_ID}`,
      titleKey: 'joinClass',
      descriptionKey: 'joinClass',
    },
  ];

  if (isAuthenticated) {
    cards.push({
      key: 'myCourses',
      to: '/courses',
      titleKey: 'myCourses',
      descriptionKey: 'myCourses',
    });
  }

  if (isAuthenticated && role === 'INSTRUCTOR') {
    cards.push({
      key: 'instructor',
      to: '/instructor',
      titleKey: 'instructor',
      descriptionKey: 'instructor',
    });
  }

  if (!isAuthenticated) {
    cards.push(
      { key: 'login', to: '/login', titleKey: 'login', descriptionKey: 'login' },
      { key: 'register', to: '/register', titleKey: 'register', descriptionKey: 'register' },
    );
  }

  return cards;
}

function HomePage() {
  const { t } = useTranslation();
  const { token, role } = useAuth();
  const cards = buildCards(Boolean(token), role);

  return (
    <>
      <MenuShell courseId={DEMO_COURSE_ID} />
      <main className="home-page">
        <header className="home-page__hero">
          <h1>{t('app.title')}</h1>
          <p className="home-page__tagline">{t('home.tagline')}</p>
        </header>

        <section className="home-page__grid" aria-label={t('app.title')}>
          {cards.map((card) => (
            <Link key={card.key} className="home-card" to={card.to}>
              <span className="home-card__prompt" aria-hidden="true">
                &gt;_
              </span>
              <span className="home-card__title">{t(`home.cards.${card.titleKey}.title`)}</span>
              <span className="home-card__description">
                {t(`home.cards.${card.descriptionKey}.description`)}
              </span>
            </Link>
          ))}
        </section>
      </main>
    </>
  );
}

export default HomePage;
